import { Card, Divider, Flex, Layout } from "antd";
import Meta from "antd/es/card/Meta";
import Navigator from "../../Components/Navigator/Index";
import AuthService from "../../Services/auth.service";
import "./index.scss";
import { Header } from "antd/es/layout/layout";

const { Content } = Layout;

const Profile = () => {
  const user = AuthService.getInstance().getCurrentUser();

  return (
    <Layout className="profile-container">
      {/* <Header style={{ padding: 0, background: "transparent" }}> */}
      <Header style={{ padding: 0 }}>
        <Navigator />
      </Header>
      <Content style={{ margin: "0 auto", height: "100vh" }}>
        <Flex
          align="center"
          justify="center"
          style={{ height: "calc(100vh - 100px)" }}
        >
          <Card hoverable style={{ width: 400 }}>
            <Meta
              title={
                user?.firstName
                  ? user.firstName.charAt(0).toUpperCase() +
                    user.firstName.slice(1)
                  : "User"
              }
              description={user?.email}
            />
          </Card>
        </Flex>
      </Content>
    </Layout>
  );
};

export default Profile;
